import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Item from './Item'
import bemClass from './../../../utils/bemClass'
import api from './../../../api'

import './MenuPanel.css'

const cn = bemClass('MenuPanel')

const menuItems = [
    {
        title: 'Program',
        url: '',
    },
]

class MenuPanel extends PureComponent {
    state = { items: null }

    getApi = async () => {
        const apiItems = await api('pages/info')
        const items = [...menuItems, ...apiItems]

        this.setState({ items })
    }

    componentWillMount() {
        this.getApi()
    }

    render() {
        const { className, active, location, onChange } = this.props
        const { items } = this.state

        return (
            <ul className={`${cn({ active })} ${className}`}>
                {items &&
                    items.map(item => (
                        <Item
                            key={item.url}
                            url={`/${item.url}`}
                            title={item.title}
                            active={
                                location === `/${item.url}` ||
                                location === `/${item.url}/`
                            }
                            onChange={onChange}
                        />
                    ))}
            </ul>
        )
    }
}

MenuPanel.propTypes = {
    className: PropTypes.string,
    active: PropTypes.bool,
    location: PropTypes.string,
    onChange: PropTypes.func,
}

MenuPanel.defaultProps = {
    active: false,
    location: '/',
    className: '',
    onChange: () => {},
}

export default MenuPanel



// WEBPACK FOOTER //
// ./src/components/Menu/MenuPanel/MenuPanel.jsx